import React from "react";
import { Link } from "react-router-dom";
import "./Error.css";

function Error() {
  return (
    <div className="err">
      <h3>This Page Is Not On The Map.</h3>
      <Link to="/">
        <button className="button">Back to Home</button>
      </Link>
    </div>
  );
}

export default Error;
